import React, { useCallback } from "react"
import { Col, Row } from "react-bootstrap"
import { useTranslationWithRef } from "../../hooks/useTranslationWithRef"
import ShowMoreGroup from "./ShowMoreGroup"
import HowToImproveGroup from "./HowToImproveGroup"
import { RangeChart, GraphReportDetail } from "amh-results"

interface RangeGraphProps {
  detail: GraphReportDetail
}

export default function RangeGraph(props: RangeGraphProps) {
  const [translationRef, t] = useTranslationWithRef()
  const { detail } = props

  const chartTranslation = useCallback((key: string) => translationRef.current(key), [translationRef])

  return (
    <>
      <Row>
        <Col xs={12} md={6} className="fw-bold text-uppercase mb-2">{detail.name}</Col>
        <Col xs={12} md={6} className="text-xs-left text-md-end">
          {detail.longDescription && <ShowMoreGroup title={detail.name} description={detail.longDescription} />}
          {detail.howToImprove && <HowToImproveGroup title={detail.name} description={detail.howToImprove} />}
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <span className="ms-3">
              {`${t("results.result")}: ${props.detail.numericResultString || props.detail.numericResult?.toString() || ""} ${props.detail.units || ""}`}
          </span>
          <span className="ms-1">
            {detail.resultStatus && detail.resultStatus != props.detail.numericResultString ? `(${detail.resultStatus})` : "" }
          </span>
        </Col>
      </Row>
      {props.detail.displayGraph && <Row>
        <Col><RangeChart range={detail.range} numericResult={detail.numericResult} translation={chartTranslation} /></Col>
      </Row>}
    </>
  )
}
